/**
 * Search configuration for the Purchase Order list view.
 *
 * Extracted into a sibling module so the user-visible copy can be unit-tested
 * without mounting the giant PurchaseOrderList.vue component (project's
 * "Simple Component Pattern" — see buyingTableSortColumns.ts for another
 * example of this pattern).
 *
 * Kept in sync with the backend `applyPurchaseOrderSearchFilter` helper in
 * assisty-bot (src/modules/apis/helpers/purchase_order_search_filter.js),
 * which is the source of truth for which fields the `?search=` param
 * actually matches. If you change the backend field list, update this copy.
 */
export const PO_SEARCH_PLACEHOLDER =
  'Search by PO number, supplier, SKU, or product name';
